import React, {useState} from "react";
import {Navbar, Nav, Container} from "react-bootstrap";
import {Link as RouterLink, useLocation, useNavigate} from 'react-router-dom';
import {scroller} from 'react-scroll';
import "../Menu/Menu.css";

function Menu() {
  const [expanded,
    setExpanded] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Função auxiliar de cálculo para centralizar (Reutilizável)
  const scrollToCenter = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
      // 1. Pega a posição absoluta do elemento no documento
      const elementTop = element.offsetTop;
      const elementHeight = element.offsetHeight;
      const windowHeight = window.innerHeight;

      // 2. Calcula o Scroll: Posição do topo do elemento - Metade da tela + Metade do
      // elemento Isso coloca o centro do elemento no centro da tela.
      let scrollToPosition = elementTop - (windowHeight / 2) + (elementHeight / 2);

      window.scrollTo({top: scrollToPosition, behavior: 'smooth'});
    }
  };

  const handleScrollLinkClick = (targetId) => {
    setExpanded(false);

    if (targetId === "initial") {
      if (location.pathname === '/') {
        // Se já está na home, usa scroller ou window.scrollTo(0,0)
        window.scrollTo({top: 0, behavior: 'smooth'});
      } else {
        navigate('/', {
          state: {
            scrollTo: targetId
          }
        });
      }
    } else if (targetId === "about") {
      if (location.pathname === '/') {
        // Se já está na Home, calcula e scrolla
        scrollToCenter(targetId);
      } else {
        // Se não, navega
        navigate('/', {
          state: {
            scrollTo: targetId
          }
        });
      }
    } else if (targetId === "initial-service" || targetId === "contact") {
      navigate('/servicos', {
        state: {
          scrollTo: targetId
        }
      });

    }
  };

  return (
    <Navbar expanded={expanded} bg="light" variant="light" expand="lg" fixed="top">
      <Container>
        <Navbar.Brand
          className="name"
          id="name"
          onClick={() => handleScrollLinkClick('initial')}>
          <div>
            <img
              src={require('../../images/nyansapo.png')}
              alt="Logo Layna Tambucci"
              style={{
              height: '30px',
              marginRight: '10px',
              verticalAlign: 'middle'
            }}/>
            <span
              style={{
              fontSize: '1.5rem',
              cursor: 'pointer'
            }}>Layna Tambucci</span>
          </div>
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          style={{
          cursor: "pointer"
        }}
          onClick={() => setExpanded(expanded
          ? false
          : true)}/>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto navbar">

            {/* SOBRE MIM */}
            <Nav.Link
              className="nav-link menu-option"
              style={{
              cursor: "pointer"
            }}
              onClick={() => handleScrollLinkClick('about')}>
              Sobre mim
            </Nav.Link>

            {/* SERVIÇOS */}
            <Nav.Link
              as={RouterLink}
              to="/servicos"
              className="nav-link menu-option"
              style={{
              cursor: "pointer"
            }}
              onClick={(e) => {
              e.preventDefault();
              handleScrollLinkClick('initial-service');
            }}>
              Serviços
            </Nav.Link>

            {/* CONTATO */}
            <Nav.Link
              className="nav-link menu-option"
              style={{
              cursor: "pointer"
            }}
              onClick={() => handleScrollLinkClick('contact')}>
              Contato
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Menu;